export type DrawingShapeKind = 'polygon' | 'rectangle' | 'circle' | 'line' | 'image';

export type DrawingShortcut = { keyLabel: string; label: string; active?: boolean; };

// Le cercle est rond et l'image garde son ratio d'elles-mêmes : Alt n'y change rien.
const CONSTRAIN_LABELS: Partial<Record<DrawingShapeKind, string>> = {
	polygon: 'Traits droits',
	line: 'Traits droits',
	rectangle: 'Carré',
};

/** Raccourcis à rappeler sur la carte pendant un tracé ou une modification, aucun sinon. */
export default function drawingShortcuts(state: {
	drawing: boolean;
	editing: boolean;
	shapeKind?: DrawingShapeKind;
	snapping: boolean;
	constrain: boolean;
}): DrawingShortcut[] {
	if (!state.drawing && !state.editing) return [];

	const constrainLabel = state.drawing && state.shapeKind ? CONSTRAIN_LABELS[state.shapeKind] : undefined;
	// La contrainte l'emporte sur le magnétisme quand les deux touches sont tenues.
	const constrained = state.constrain && !!constrainLabel;

	return [
		{ keyLabel: 'Maj ⇧', label: 'Magnétisme', active: state.snapping && !constrained },
		...(constrainLabel ? [{ keyLabel: 'Alt ⌥', label: constrainLabel, active: state.constrain }] : []),
		// En modification, Échap quitte l'édition en gardant les changements : il ne les annule pas.
		{ keyLabel: 'Échap', label: state.drawing ? 'Annuler' : 'Terminer' },
	];
}
